import * as React from 'react';
import styles from 'src/components/AssortmentScopeSelector/AssortmentScopeSelector.styles';
import { FloorsetConfigResponse } from 'src/types/Scope';
import { LensProp } from '../TargetSetting/TargetSetting.types';
import ScopeSelectorDropdown from 'src/components/AssortmentScopeSelector/AssortmentScopeSelectorDropdown';
import { FloorsetAttrResponse } from '../../../../types/Scope';
import { Lens, Optional } from 'monocle-ts';
import { PeriodFormReduxSlice } from '../DatePicking/PeriodForm.types';
import {
  floorsetDropdownTitle,
  loadingText,
} from 'src/components/AssortmentScopeSelector/FloorSetSelectorForm/FloorsetSelectorForm.styles';
import targetStyles from './TargetCreation.styles';
import { classes as mergeClasses } from 'typestyle';
import { SelectedTypes } from 'src/pages/AssortmentStrategy/TargetSetting/TargetCreation/TargetCreation.types';
import { AppState } from 'src/store';

export interface ValueProps {
  floorsetConfig: FloorsetConfigResponse;
  selectedFloorset?: string | null;
  selectedProductMember: string | null;
  invalid?: string;
  isLoading: boolean;
  locked: boolean;
}

export interface FunctionProps {
  onChangeFloorset?(floorset: string): void;
  onClickGetFloorset?(productMemberId: string): void;
}

export interface FloorsetReduxSlice {
  selectedFloorset?: string;
}

export interface OwnProps extends LensProp<AppState, FloorsetReduxSlice> {
  productIdLens: Lens<AppState, string>;
  salesLens?: Optional<AppState, PeriodFormReduxSlice>;
  receiptLens?: Optional<AppState, PeriodFormReduxSlice>;
  floorsetsLens: Lens<AppState, FloorsetConfigResponse>;
  selectedLens?: Lens<AppState, SelectedTypes>;
  updateFloorSetAttribs?(attributes: FloorsetAttrResponse): void;
}

export interface FloorsetProps extends ValueProps, FunctionProps, OwnProps {}

export default class FloorsetSelectorForm extends React.Component<FloorsetProps> {
  constructor(props: FloorsetProps) {
    super(props);
  }

  componentDidMount() {
    const { selectedProductMember } = this.props;
    this.handleClickGetFloorset(selectedProductMember);
  }

  handleFloorsetChange = (id: string): void => {
    const { onChangeFloorset } = this.props;
    if (onChangeFloorset) {
      onChangeFloorset(id);
    }
  };

  handleClickGetFloorset = (productMemberId: string | null): void => {
    const { onClickGetFloorset, isLoading } = this.props;
    if (productMemberId && !isLoading && onClickGetFloorset) {
      onClickGetFloorset(productMemberId);
    }
  };

  render() {
    const { floorsetConfig, selectedFloorset, selectedProductMember, invalid, isLoading } = this.props;

    let placeHolder = <div className={floorsetDropdownTitle}>Getting Floorsets...</div>;

    if (isLoading) {
      placeHolder = (
        <div className={mergeClasses(targetStyles.floorset.loadText, `${loadingText}`)} style={{ cursor: 'wait' }} />
      );
    }

    let floorSet = (
      <div
        onClick={() => this.handleClickGetFloorset(selectedProductMember)}
        className={styles.scopeSelectorDropdownSmall}
      >
        {placeHolder}
      </div>
    );

    if (floorsetConfig && floorsetConfig.length > 0) {
      floorSet = (
        <ScopeSelectorDropdown
          options={floorsetConfig}
          placeholder={'Select Floorset'}
          selection={selectedFloorset || undefined}
          invalid={invalid}
          handleChangeOnDropdown={this.handleFloorsetChange}
          locked={false}
          qa="dropdown-assortmentfloorset"
          applyClass={targetStyles.floorset.form}
        />
      );
    }

    return <React.Fragment>{floorSet}</React.Fragment>;
  }
}
